import { Button, Flex, FormLabel, Modal, ModalBody, ModalContent, ModalOverlay, Radio, Stack, useDisclosure } from "@chakra-ui/react"
import { FiSave } from "react-icons/fi"
import { useEffect } from 'react';
import { InputField } from "../../../components"
import RadioField from "../../../components/RadioField";
import InputImage from "../../../components/InputImage";
import { notaEntregueNaoPallet, notaEntreguePallet } from "../utils/montarGestoesDaEntrega";
import type { EntregaGrupoFormValues } from "../utils/montarGestoesDaEntrega";

interface IProps {
  onOpenModal: boolean;
  onOpenedModal: () => void;
  onSubmited: () => void;
  isLoading?: boolean;
  values: EntregaGrupoFormValues;
}

const ModalObservacoesGrupo = ({ onOpenModal, onOpenedModal, onSubmited, isLoading = false, values }: IProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  useEffect(() => {
    if (onOpenModal) {
      onOpen();
      onOpenedModal();
    }
  }, [onOpenModal]);

  const perguntaDevolucaoMercadoria = values.notas.some(notaEntregueNaoPallet);

  return (
    <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalBody>
          <FormLabel mt={4}>Como foi esta entrega? Se houve algum problema e queira nos relatar, escreva abaixo!</FormLabel>
          <InputField
            rows={3}
            textarea={true}
            type="textarea"
            label=""
            placeholder="Escreva aqui... (Opcional)"
            name="observacoes"
          />

          {values.notas.map((nota, indice) => notaEntreguePallet(nota) && (
            <Flex key={nota.j10_ukey} direction="column" mt={2}>
              <FormLabel mb={0} mt={2}>Pallet da NF {nota.nota_numero} está retornando?</FormLabel>
              <RadioField name={`notas[${indice}].status_nota_pallet_gestao_entrega`}>
                <Stack mx="auto" direction="row" bg="white" p={4} borderRadius={5}>
                  <Radio size="lg" value={2}>Sim</Radio>
                  <Radio size="lg" value={1}>Não</Radio>
                  <Radio size="lg" value={3}>Emitiu vale pallet</Radio>
                </Stack>
              </RadioField>

              {nota.status_nota_pallet_gestao_entrega == 1 && <Flex width={"full"} justifyContent={'center'}>
                <InputField textarea rows={3} name={`notas[${indice}].motivo_nao_retorno_do_vale_pallet`} label="Explique por que não vai ter o retorno" />
              </Flex>}
              {nota.status_nota_pallet_gestao_entrega == 3 && <Flex width={"full"} justifyContent={'center'}>
                <InputImage label={`Adicionar Foto do Vale Pallet (NF ${nota.nota_numero})`} name={`notas[${indice}].url_imagem_vale_pallet`} />
              </Flex>}
            </Flex>
          ))}

          {perguntaDevolucaoMercadoria && <>
            <FormLabel mb={0} mt={2}>Cliente devolveu alguma mercadoria ou fez alguma nota de devolução?</FormLabel>
            <RadioField name="teve_devolucao_mercadoria">
              <Stack mx="auto" direction="row" bg="white" p={4} borderRadius={5}>
                <Radio size="lg" value={1}>Sim</Radio>
                <Radio size="lg" value={0}>Não</Radio>
              </Stack>
            </RadioField>
            {values.teve_devolucao_mercadoria == 1 && <Flex pb={4} width="full" justifyContent="center" wrap="wrap">
              <InputImage label="Adicionar Foto da Nota Fiscal" name="url_imagem_devolucao_mercadoria" />
            </Flex>}
          </>}

          <Button isLoading={isLoading} isDisabled={isLoading} mt={4} mb={4} py={6} width="full" colorScheme="green" onClick={onSubmited}>Concluir &nbsp; <FiSave fontSize={18} /> </Button>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default ModalObservacoesGrupo;
